export const LowStockSalesPitch = ({selectedVariant}) => {
  // console.log('[LowStockSalesPitch] selectedVariant:', selectedVariant);
  let tpaAndLvQtyCombinedRealOhTotal = (selectedVariant?.tpa_wh ?? 0) + (selectedVariant?.lv_wh ?? 0);
  if (!tpaAndLvQtyCombinedRealOhTotal || tpaAndLvQtyCombinedRealOhTotal < 0) {
    tpaAndLvQtyCombinedRealOhTotal = selectedVariant?.total_qty_without_fba ?? 0;
  }

  if (tpaAndLvQtyCombinedRealOhTotal === 0) {
    return (
      <div
        className="mt-2 bg-red-100 border-l-4 border-red-500 p-4 mb-4 rounded-md shadow-md border-orange-500"
        style={{backgroundColor: 'rgb(250,226,162)'}}
      >
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm font-bold text-red-700">
              This item is currently out of stock.
            </p>
            <p className="mt-1 text-xs text-red-600">
              Please check back later or contact us for more information.
            </p>
          </div>
        </div>
      </div>
    );
  }

  const isLowStockTrue = tpaAndLvQtyCombinedRealOhTotal < 5;

  if (isLowStockTrue) {
    return (
      <div
        className="mt-2 bg-orange-100 border-l-4 border-orange-500 p-4 mb-4 rounded-md shadow-md">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-orange-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm font-bold text-orange-700">
              Low stock alert! Only {tpaAndLvQtyCombinedRealOhTotal} left in stock!
            </p>
            <p className="mt-1 text-xs text-orange-600">
              Don't miss out - add to cart now before it's gone!
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};
